module.exports = __webpack_public_path__ + "static/img/3.c4dc1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newFour/3.png
// module id = VYkF
// module chunks = 0